import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e84a8fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "registration-agreement"
}
const _hoisted_2 = { class: "text-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "title__row" }
const _hoisted_5 = { class: "title__row" }
const _hoisted_6 = {
  href: "https://www.casedrive.co/business-associate-agreement.html",
  target: "_blank"
}
const _hoisted_7 = { class: "title__row" }
const _hoisted_8 = {
  key: 1,
  class: "wrapper"
}
const _hoisted_9 = { class: "text-wrapper" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "title__row" }
const _hoisted_12 = { class: "title__row" }
const _hoisted_13 = {
  href: "https://www.casedrive.co/business-associate-agreement.html",
  target: "_blank"
}
const _hoisted_14 = { class: "title__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$localize('registration.agreement.description.1')), 1),
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.description.2.1')) + " ", 1),
              _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$localize('registration.agreement.description.link')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$localize('registration.agreement.description.2.2')), 1)
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$localize('registration.agreement.description.3')), 1)
          ])
        ]),
        _createVNode(_component_Form, {
          onSubmit: _ctx.nextStep,
          as: "el-form",
          class: "registration-agreement__form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_checkbox, {
              class: "app-form-control",
              modelValue: _ctx.coveredValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.coveredValue) = $event)),
              name: "covered",
              "align-start": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.covered')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_checkbox, {
              class: "app-form-control",
              modelValue: _ctx.protectedValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.protectedValue) = $event)),
              name: "protected",
              "align-start": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.protected')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_checkbox, {
              class: "app-form-control",
              modelValue: _ctx.authorizedValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.authorizedValue) = $event)),
              name: "authorized",
              "align-start": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.authorized')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_button, {
              disabled: !_ctx.coveredValue || !_ctx.protectedValue || !_ctx.authorizedValue,
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.email.button')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$localize('registration.agreement.description.1')), 1),
            _createElementVNode("p", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.description.2.1')) + " ", 1),
              _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$localize('registration.agreement.description.link')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$localize('registration.agreement.description.2.2')), 1)
            ]),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$localize('registration.agreement.description.3')), 1)
          ])
        ]),
        _createVNode(_component_Form, {
          onSubmit: _ctx.nextStep,
          as: "el-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_checkbox, {
              class: "app-form-control",
              modelValue: _ctx.coveredValue,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.coveredValue) = $event)),
              name: "covered",
              "align-start": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.covered')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_checkbox, {
              class: "app-form-control",
              modelValue: _ctx.protectedValue,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.protectedValue) = $event)),
              name: "protected",
              "align-start": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.protected')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_checkbox, {
              class: "app-form-control",
              modelValue: _ctx.authorizedValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.authorizedValue) = $event)),
              name: "authorized",
              "align-start": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.agreement.authorized')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_app_button, {
              disabled: !_ctx.coveredValue || !_ctx.protectedValue || !_ctx.authorizedValue,
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('registration.email.button')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ]))
}